import * as React from 'react';
import { CSSProperties } from 'react';
import { LocalDate } from '@js-joda/core';
import { formatDateFull, formatMonthShort, formatWeekdayShort } from '@unifocus/js-utils';
import { Tooltip } from '../tooltip';

/**
 * {@docCategory DateIcon}
 */
export interface DateIconProps {
   /**
    * The date to display.
    */
   date: LocalDate;

   /**
    * Set the className.
    */
   className?: string;

   /**
    * Set styles.
    */
   style?: CSSProperties;
}

export const DateIcon = (props: DateIconProps) => {
   const { date, ...restProps } = props;
   const clsPrefix = 'uf-date-icon';

   return (
      <Tooltip title={formatDateFull(props.date)}>
         <div {...restProps} className={`${clsPrefix} ${props.className || ''}`} style={props.style}>
            <div className={`${clsPrefix}__day-of-the-week`}>
               {formatWeekdayShort(date)}
            </div>

            <div className={`${clsPrefix}__date-info`}>
               <div className={`${clsPrefix}__date-info__month`}>
                  {formatMonthShort(date)}
               </div>

               <div className={`${clsPrefix}__date-info__day`}>
                  {date.dayOfMonth()}
               </div>
            </div>
         </div>
      </Tooltip>
   );
};
